import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputMask } from "primereact/inputmask";
import { InputText } from 'primereact/inputtext';
import { useState } from "react";
import Cards from "react-credit-cards";
import "react-credit-cards/lib/styles.scss";
import { toast } from "react-toastify";
import { useInfo } from "../context/GeneralInfoContext";
import { format } from "date-fns";
import { ValidaCartaoCreditoZoop } from "../services/ZoopRoutes";
import { usePrivate } from "../context/PrivateInfoContext";

function CreditCardDialog({close,negotiate}){
 const { today } = useInfo()
 const {cartaoNumero,setCartaoNumero} = usePrivate()
//  const [cartaoNumero,setCartaoNumero] = useState('');
 const [cartaoNome,setCartaoNome] = useState('');
 const [cartaoVencimento,setCartaoVencimento] = useState('');
 const [cartaoCVC,setCartaoCVC] = useState('');
 const [campoFoco,setCampoFoco] = useState('');
 const [diaVencimento,setDiaVencimento] = useState('');
 const [anoVencimento,setAnoVencimento] = useState('')

 function ValidaVencimento(e){
    const anoAtual = format(today,'yy')
    if(Number(e.slice(0,2)) <= 12 && Number(e.slice(-2)) >= Number(anoAtual)){
    setDiaVencimento(e.slice(0,2));
    setAnoVencimento(e.slice(-2));
    } else {
        setCartaoVencimento('')
        toast.error('Vencimento Inválido!')
    }
 }

 function ValidaCartao(event){
    event.preventDefault()
    const cardData = {
    card_number: cartaoNumero,
    holder_name: cartaoNome,
    security_code: cartaoCVC, 
    expiration_month: diaVencimento, 
    expiration_year: anoVencimento,
    }
    ZoopValidacao(cardData)
 }

 const ZoopValidacao = async(cardData) =>{
     try {
        const data = await ValidaCartaoCreditoZoop(cardData)
        negotiate(data.id)
        console.log(data);
     } catch (error) {
        console.log(error)
        if(error.response === undefined)
        return toast.error("Erro de Conexão!")
        if(error.response.status === 500)
        toast.error("Serviço de verificação de cartão indisponível!")
        if(error.response.status === 402)
        toast.error("Cartão inválido verifique os campos!") 
     }
 }



    return (
    <Dialog
    visible
    header="Pagar com cartão de crédito"
    onHide={()=>close()}
    style={{
        minHeigth:'30vw', 
        minWidth: '20vw', 
        textAlign: 'center', 
        borderRadius: "0.75rem",
    }}
    draggable={false} 
    className="boletosDialog"
    >
        <div className="grid p-1 text-left">
            <div>
                <Cards
                cvc={cartaoCVC}
                expiry={cartaoVencimento}
                name={cartaoNome}
                number={cartaoNumero}
                focused={campoFoco}
                placeholders={{ name: "NOME" }}
                // callback={(e) => setMatLengthCard(e.maxLength)}
                locale={{ valid: "Válido até" }}
                />
            </div>
            <form onSubmit={e=>ValidaCartao(e)} >
            <div className="flex flex-col mt-4 font-bold gap-2">
                <div className="flex flex-col">
                    <label>Número do Cartão</label>
                    <InputMask
                    name="number"
                    value={cartaoNumero}
                    onFocus={e=>{setCampoFoco(e.target.name)}}
                    onChange={e=>setCartaoNumero(e.value)}
                    placeholder="ex: 9999 9999 9999 9999"
                    required
                    mask="9999 9999 9999 9999"
                    //tooltipOptions={}
                    unmask
                    />
                </div>
                <div className="flex flex-col">
                    <label>Nome Cartão(exatamente como o impresso no cartão)</label>
                    <InputText
                    name="name"
                    value={cartaoNome}
                    onFocus={e=>{setCampoFoco(e.target.name)}}
                    onChange={e=>setCartaoNome(e.target.value)}
                    placeholder="ex: FERNANDO NUNES"
                    required
                    />
                </div>
                <div className="flex flex-col">
                    <label>Vencimento do Cartão</label>
                    <InputMask 
                    name="expiry"
                    value={cartaoVencimento}
                    onFocus={e=>{setCampoFoco(e.target.name)}}
                    onChange={e=>setCartaoVencimento(e.value)}
                    onComplete={e=>ValidaVencimento(e.value)}
                    placeholder="ex: MM/AA"
                    required
                    mask="99/99"
                    />
                </div>
                <div className="flex flex-col"> 
                    <label>Código de Segurança (CVC/CVV)</label>
                    <InputText
                    name="cvc"
                    value={cartaoCVC}
                    onFocus={e=>{setCampoFoco(e.target.name)}}
                    onChange={e=>setCartaoCVC(e.target.value)}
                    required
                    placeholder="ex: 999"
                    />
                </div>
                <div className="paymentButton mt-2">
                    <Button label="Pagar" type="submit" />
                </div>
            </div>
            </form>
        </div>

    </Dialog>
)
}

export default CreditCardDialog